<template>
  <base-modal
    :showing="visible"
    size="max-w-full"
    :full-width="false"
    @close="$emit('close')"
  >
    <div class="space-y-4">
      <QrCode
        :text="detail.qris"
        error-level="L"
        :size="400"
        class="flex justify-center rounded-md border p-4"
      />
      <div class="space-y-2 text-center">
        <p class="text-gray-700">{{ detail.orderCode }}</p>
        <p class="text-gray-700">
          {{ detail.qris_merchant }} -
          {{ detail.qris_city }}
        </p>
        <p class="text-gray-700">
          {{ detail.bank_account_name }} -
          {{ detail.bank_account_number }}
        </p>
        <p class="text-xl font-bold text-gray-900">
          Rp. {{ detail.price | toCurrency }}
        </p>
      </div>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal.vue';
import QrCode from 'vue-qrcode-component';

export default {
  components: {
    BaseModal,
    QrCode
  },
  props: {
    visible: Boolean,
    detail: Object
  },
  emits: ['close']
}
</script>